import { mainPath } from "../../lib/mainPath";
import { requestsTemplates } from "../../lib/requestsTemplates";

export const getCurrentUserVacationStatus = (params) =>
  requestsTemplates.get(mainPath, `/getCurrentUser/vacations`, params);
